import React, { Component } from "react";
import {
  Route,
  NavLink,
  BrowserRouter
} from "react-router-dom";
import Home from "./Home";
import AppMgmt from "./AppMgmt";
import Support from "./Support";
import VendorMgmt from "./VendorMgmt";
//import {AppMgmt,RootCloseWrapperExample} from "./AppMgmt";
import LoginPage from "./LoginPage";
import LogoutUser from "./Logout";

class Main extends Component {
  render() {
    return (
      <BrowserRouter >
        <div align="center">
          <h1  id="Main" align="center"><div id="Main">Management Console</div></h1>
          <div className="header">
            <ul className="header">
              <li><NavLink exact to="/Home">Home</NavLink></li>
              <li><NavLink to="/App">Application Management</NavLink></li>
              <li><NavLink to="/Vendor">Vendor Management</NavLink></li>
              {/* <li><NavLink to="/RootCloseWrapper">RootCloseWrapper</NavLink></li> */}
              <li><NavLink to="/Support">Support</NavLink></li>
              <li className="float-right"><NavLink to="/Logout"><span className="glyphicon glyphicon-log-out"></span></NavLink></li>
            </ul>
          </div>

          <div className="container">
            <Route exact path="/" component={LoginPage} />
            <Route path="/Home" component={Home} />
            <Route path="/App" component={AppMgmt} />
            <Route path="/Vendor" component={VendorMgmt} />
            {/* <Route path="/RootCloseWrapper" component={RootCloseWrapperExample} /> */}
            <Route path="/Support" component={Support} />
            <Route path="/Logout" component={LogoutUser} />
          </div>
        </div>
      </BrowserRouter >
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js